<div>
  <app-mobile-tile *ngFor="let tile of tileData" [tile]="tile"></app-mobile-tile>
</div>
